(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tob-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tob-collection-grid')) {
    customElements.define(
      'tob-collection-grid',
      class TobCollectionGrid extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('.tob-cg__search input');
          if (!input) return;
          this.items = Array.from(this.querySelectorAll('.tob-cg__item'));
          this.headers = Array.from(this.querySelectorAll('.tob-cg__letter'));
          this.navLinks = Array.from(this.querySelectorAll('.tob-cg__nav a'));
          this.noResults = this.querySelector('.tob-cg__no-results');
          input.addEventListener('input', () => this.filter(input.value));
        }

        filter(raw) {
          const q = raw.trim().toLowerCase();
          const letters = new Set();
          let count = 0;
          this.items.forEach((el) => {
            const match = !q || el.dataset.title.includes(q);
            el.hidden = !match;
            if (match) {
              letters.add(el.dataset.letter);
              count++;
            }
          });
          this.headers.forEach((h) => (h.hidden = !letters.has(h.dataset.letter)));
          this.navLinks.forEach((a) => a.setAttribute('aria-disabled', letters.has(a.dataset.letter) ? 'false' : 'true'));
          if (this.noResults) this.noResults.hidden = count > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tob-drop-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Offset (ms) of a time zone from UTC at a given instant.
    function tzOffset(ts, tz) {
      const p = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(ts)).forEach((x) => (p[x.type] = x.value));
      const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      return asUtc - Math.floor(ts / 1000) * 1000;
    }
    // Wall-clock date/time in a time zone -> UTC ms (handles daylight saving).
    function zonedToUtc(y, mo, d, h, mi, tz) {
      const guess = Date.UTC(y, mo, d, h, mi);
      let t = guess - tzOffset(guess, tz);
      const o2 = tzOffset(t, tz);
      if (guess - o2 !== t) t = guess - o2;
      return t;
    }
    // Drop instants (UTC ms) for the drop weekday in the 8 days before and after "now".
    function dropTimes(now, day, hour, minute, tz) {
      const p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date(now)).forEach((x) => (p[x.type] = x.value));
      const out = [];
      for (let k = -8; k <= 8; k++) {
        const wall = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + k));
        if (wall.getUTCDay() !== day) continue;
        out.push(zonedToUtc(wall.getUTCFullYear(), wall.getUTCMonth(), wall.getUTCDate(), hour, minute, tz));
      }
      return out;
    }
    window.TobDropCountdownMath = { dropTimes };

    if (!customElements.get('tob-drop-countdown')) {
      customElements.define(
        'tob-drop-countdown',
        class TobDropCountdown extends HTMLElement {
          connectedCallback() {
            this.cfg = {
              day: +this.dataset.day, hour: +this.dataset.hour, minute: +this.dataset.minute,
              tz: this.dataset.tz || 'America/New_York',
              liveMs: (+this.dataset.liveHours || 0) * 3600000,
              seconds: this.dataset.showSeconds === 'true'
            };
            this.count = this.querySelector('[data-state="count"]');
            this.live = this.querySelector('[data-state="live"]');
            this.units = {};
            this.querySelectorAll('[data-u]').forEach((el) => (this.units[el.dataset.u] = el));
            this.tick();
            this.timer = setInterval(() => this.tick(), this.cfg.seconds ? 1000 : 15000);
          }
          disconnectedCallback() { clearInterval(this.timer); }
          tick() {
            const c = this.cfg, now = Date.now();
            let times;
            try { times = dropTimes(now, c.day, c.hour, c.minute, c.tz); } catch (e) { return; } // bad time zone: leave static text
            const last = times.filter((t) => t <= now).pop();
            const next = times.find((t) => t > now);
            const isLive = last !== undefined && now - last < c.liveMs;
            this.count.hidden = isLive;
            this.live.hidden = !isLive;
            if (isLive || next === undefined) return;
            let s = Math.floor((next - now) / 1000);
            const d = Math.floor(s / 86400); s -= d * 86400;
            const h = Math.floor(s / 3600); s -= h * 3600;
            const m = Math.floor(s / 60); s -= m * 60;
            const pad = (n) => String(n).padStart(2, '0');
            if (this.units.d) this.units.d.textContent = d;
            if (this.units.h) this.units.h.textContent = pad(h);
            if (this.units.m) this.units.m.textContent = pad(m);
            if (this.units.s) this.units.s.textContent = pad(s);
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tob-metafield-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tob-metafield-directory')) {
    customElements.define(
      'tob-metafield-directory',
      class TobMetafieldDirectory extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('.tob-dir__search input');
          if (!input) return;
          this.items = Array.from(this.querySelectorAll('.tob-dir__item'));
          this.groups = Array.from(this.querySelectorAll('.tob-dir__group'));
          this.navLinks = Array.from(this.querySelectorAll('.tob-dir__nav a'));
          this.noResults = this.querySelector('.tob-dir__no-results');
          input.addEventListener('input', () => this.filter(input.value));
        }
        filter(raw) {
          const q = raw.trim().toLowerCase();
          this.items.forEach((li) => (li.hidden = q !== '' && !li.dataset.name.includes(q)));
          const live = new Set();
          this.groups.forEach((g) => {
            const any = g.querySelector('.tob-dir__item:not([hidden])') !== null;
            g.hidden = !any;
            if (any) live.add(g.dataset.letter);
          });
          this.navLinks.forEach((a) => a.setAttribute('aria-disabled', live.has(a.dataset.letter) ? 'false' : 'true'));
          if (this.noResults) this.noResults.hidden = live.size > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tob-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tob-testimonials')) return;

    // CSV parser for Google's published sheets (quoted fields, "" escapes, commas and line breaks inside quotes).
    function parseCsv(text) {
      const rows = [];
      let row = [], field = '', inQ = false;
      for (let i = 0; i < text.length; i++) {
        const c = text[i];
        if (inQ) {
          if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else { inQ = false; } }
          else field += c;
        } else if (c === '"') inQ = true;
        else if (c === ',') { row.push(field); field = ''; }
        else if (c === '\n' || c === '\r') {
          if (c === '\r' && text[i + 1] === '\n') i++;
          row.push(field); rows.push(row); row = []; field = '';
        } else field += c;
      }
      if (field !== '' || row.length) { row.push(field); rows.push(row); }
      return rows;
    }

    // Find columns by heading, so columns added to the Public tab later don't break the site.
    function columnIndexes(header) {
      const h = header.map((x) => String(x || '').trim().toLowerCase());
      const find = (test) => h.findIndex(test);
      return {
        name: find((x) => x.startsWith('name')),
        where: find((x) => x.startsWith('city')),
        quote: find((x) => x.startsWith('quote')),
        who: find((x) => x.startsWith('reply from') || x.startsWith('responder')),
        reply: find((x) => (x.startsWith('reply') && !x.startsWith('reply from')) || x.startsWith('tob response')),
      };
    }

    customElements.define(
      'tob-testimonials',
      class TobTestimonials extends HTMLElement {
        connectedCallback() {
          const url = this.dataset.sheetUrl;
          if (!url) { this.init(); return; }
          const done = (ok) => { if (this.started) return; this.classList.remove('is-loading'); this.init(); };
          const timer = setTimeout(() => done(false), 4000);   // slow Google: fall back to the Shopify quotes
          fetch(url, { credentials: 'omit' })
            .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
            .then((text) => {
              clearTimeout(timer);
              if (this.started) return;
              const n = this.buildFromSheet(text);
              done(n > 0);
            })
            .catch(() => { clearTimeout(timer); done(false); });
        }

        buildFromSheet(text) {
          const rows = parseCsv(text.replace(/^﻿/, ''));
          if (rows.length < 2) return 0;
          const col = columnIndexes(rows[0]);
          if (col.quote < 0) return 0;
          const showWhere = this.dataset.showLocation === 'true';
          const label = this.dataset.replyLabel || '[who] replied:';
          const defWho = this.dataset.defaultWho || 'ToB';
          const size = this.dataset.quoteSize || 'medium';
          const frag = document.createDocumentFragment();
          let count = 0;
          rows.slice(1).forEach((r) => {
            const get = (i) => (i >= 0 && r[i] != null ? String(r[i]).trim() : '');
            const quote = get(col.quote);
            if (!quote) return;
            const fig = document.createElement('figure');
            fig.className = 'tob-tm__slide';
            fig.setAttribute('role', 'group');
            fig.setAttribute('aria-roledescription', 'slide');
            const bq = document.createElement('blockquote');
            bq.className = 'tob-tm__quote tob-tm__quote--' + size;
            bq.textContent = quote;
            fig.appendChild(bq);
            const name = get(col.name), where = showWhere ? get(col.where) : '';
            if (name || where) {
              const cap = document.createElement('figcaption');
              cap.className = 'tob-tm__who';
              if (name) { const s = document.createElement('span'); s.className = 'tob-tm__name'; s.textContent = name; cap.appendChild(s); }
              if (name && where) { const d = document.createElement('span'); d.className = 'tob-tm__dot'; d.setAttribute('aria-hidden', 'true'); d.textContent = ' · '; cap.appendChild(d); }
              if (where) { const s = document.createElement('span'); s.className = 'tob-tm__where'; s.textContent = where; cap.appendChild(s); }
              fig.appendChild(cap);
            }
            const reply = get(col.reply);
            if (reply) {
              const p = document.createElement('p');
              p.className = 'tob-tm__reply';
              const w = document.createElement('span');
              w.className = 'tob-tm__reply-who';
              w.textContent = label.replace('[who]', get(col.who) || defWho);
              p.appendChild(w);
              p.appendChild(document.createTextNode(' ' + reply));
              fig.appendChild(p);
              fig.dataset.hasReply = '1';
            }
            frag.appendChild(fig);
            count++;
          });
          if (count) {
            const track = this.querySelector('.tob-tm__track');
            track.replaceChildren(frag);
          }
          return count;
        }

        init() {
          this.started = true;
          const track = this.querySelector('.tob-tm__track');
          this.slides = Array.from(this.querySelectorAll('.tob-tm__slide'));
          if (!this.slides.length) return;
          if (this.dataset.order === 'shuffle') {
            for (let i = this.slides.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [this.slides[i], this.slides[j]] = [this.slides[j], this.slides[i]];
            }
            this.slides.forEach((el) => track.appendChild(el));
          }
          this.speed = Math.max(3000, +this.dataset.speed || 6000);
          this.replyExtra = Math.max(0, +this.dataset.replyExtra || 0);
          this.i = this.dataset.order === 'in_order' ? 0 : Math.floor(Math.random() * this.slides.length);
          this.userPaused = false;
          this.hoverPaused = false;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.show(this.i);
          this.classList.add('is-ready');

          this.querySelectorAll('[data-dir]').forEach((b) =>
            b.addEventListener('click', () => { this.show(this.i + +b.dataset.dir); this.restart(); })
          );
          this.pauseBtn = this.querySelector('[data-pause]');
          if (this.pauseBtn) {
            if (this.reduce) this.setUserPaused(true);
            this.pauseBtn.addEventListener('click', () => this.setUserPaused(!this.userPaused));
          }
          this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.restart(); });
          this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.restart(); });
          this.addEventListener('focusin', () => { this.hoverPaused = true; this.restart(); });
          this.addEventListener('focusout', () => { this.hoverPaused = false; this.restart(); });
          this.restart();
        }
        disconnectedCallback() { clearTimeout(this.timer); }
        setUserPaused(p) {
          this.userPaused = p;
          if (this.pauseBtn) {
            this.pauseBtn.setAttribute('aria-pressed', String(p));
            this.pauseBtn.setAttribute('aria-label', p ? 'Play quotes' : 'Pause quotes');
            this.pauseBtn.innerHTML = p ? '&#9654;' : '&#10073;&#10073;';
          }
          this.restart();
        }
        restart() {
          clearTimeout(this.timer);
          if (!this.slides || this.slides.length < 2 || this.userPaused || this.hoverPaused || this.reduce) return;
          // Quotes with a reply stay up longer.
          const cur = this.slides[this.i];
          const wait = this.speed + (cur && cur.dataset.hasReply ? this.replyExtra : 0);
          this.timer = setTimeout(() => { this.show(this.i + 1); this.restart(); }, wait);
        }
        show(n) {
          const len = this.slides.length;
          this.i = ((n % len) + len) % len;
          this.slides.forEach((el, k) => {
            const on = k === this.i;
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-hidden', String(!on));
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
